import { _IdGenerator } from '@angular/cdk/a11y';
import { Component, inject, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'kh-labeled-field',
  styleUrls: ['./labeled-field.component.less'],
  templateUrl: './labeled-field.component.html',
  standalone: false
})
export class LabeledFieldComponent {
  @Input() public controlValue!: FormControl;
  @Input() public placeholder = '';
  @Input() public inputId = inject(_IdGenerator).getId('kh-labeled-field-');

  public get labelId(): string {
    return `${this.inputId}-label`;
  }
}
